/* React */
import React from 'react';
import { useAuth } from '../../../../hooks/auth';
import { HeaderMenu } from '../../../../components/HeaderMenu';

import { Container, MidContent, RightContent, Button } from './styles';

import logoWhite from '../../../../assets/img/logoWhite.png';

import { FiLogOut } from 'react-icons/fi';
import { ImExit } from 'react-icons/im';
import { Link } from 'react-router-dom';
import { IoIosNotifications, IoMdSettings } from 'react-icons/io';
import { FaUserPlus } from 'react-icons/fa';

interface HeaderProps {
  openLeaveLeagueModal: () => void;
  isAdmin: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  openLeaveLeagueModal,
  isAdmin,
}: HeaderProps) => {
  const { logOut } = useAuth();

  return (
    <Container>
      <HeaderMenu />
      <MidContent>
        <img src={logoWhite} alt="logo" />
      </MidContent>
      <RightContent>
        <div>
          {isAdmin && (
            <>
              <Link to="/leagues/notifications">
                <IoIosNotifications size={25} />
              </Link>
              <Link to="/leagues/users">
                <FaUserPlus size={25} />
              </Link>
              <Link to="/leagues/settings">
                <IoMdSettings size={25} />
              </Link>
            </>
          )}
          <Button buttonColor="" onClick={openLeaveLeagueModal}>
            <p className="leave-league">Deixar Liga</p>
            <ImExit size={20} />
          </Button>
        </div>

        <span>
          <Button buttonColor="" onClick={openLeaveLeagueModal}>
            <p className="leave-league">Sair Liga</p>
            <ImExit size={20} />
          </Button>

          <Button buttonColor="purple" onClick={logOut}>
            <p>Sair</p>
            <FiLogOut size={20} />
          </Button>
        </span>
      </RightContent>
    </Container>
  );
};
